import './assets/css/ui-cover.less'
import logo from './assets/images/logo/nav-logo.png'
import NavHeader from './components/nav/NavHeader.vue'
import NavFooter from './components/nav/NavFooter.vue'
import NavMenu from './components/nav/NavMenu.vue'

import unConfirm from './components/receivable/authentic/UnConfirm.vue'
import loanSearch from './components/loan/Search.vue'
import repaySearch from './components/repay/Search.vue'
import receiveableSearch from './components/loan/FinanceSearch.vue'
import confirmSearch from './components/confirm/Search.vue'
import supplierSearch from './components/supplier/Search.vue'
import protocolSearch from './components/protocol/Search.vue'

const openIndex = () => import('./components/open/index.vue')
const openFlow = () => import('./components/open/Flow.vue')

export default {
  // entName: '企业的采购融资',
  entLogo: logo,
  servicePhone: '400-618-3638',
  servicePhoneTag: '<a class="text-primary" href=\'tel:400-618-3638\'>400-618-3638</a>',
  bankAccountName: '测试企业的采购融资公司',
  bankAccount: '6222111119821828',
  primaryColor: '#EE323A',
  /**
   * 设置路由子路由，详情等页面是否子路由，入参默认设置都是一级路由，这里也可以覆盖路由对应的组件
   * @param {Object} route 路由
   * @returns Boolean
   * 覆盖路由组件
   * if(route.name==='open') {
   *    route.component = () => import('./components/Open.vue'),
   * }
   *
   */
  checkRoute: route => {
    console.log(route)
    let routes = new Set(['loan-detail', 'confirm-detail', 'repay-detail', 'cumtomer-account-bank'])
    if (route.name == 'open' || route.name == 'flow') {
      // 开通转入流程
      route.component = route.name == 'open' ? openIndex : openFlow
      route.meta = {}
    }
    if (routes.has(route.name)) {
      return true
    }
    return false
  },
  //搜索组件label位置
  searchLabelPosition: 'top',
  searchInline: true,
  nav: {
    /*bgNav: '#fff', textNavColor: 'rgba(0,0,0,0.85)', bgMenu: '#fff', textMenuColor: 'rgba(0,0,0,0.85)', activeTextMenuColor: 'var(--primary-color-1)' */
    navHeader: NavHeader,
    navFooter: NavFooter,
    navMenu: NavMenu,
  },
  //准入相关配置
  access: {
    //是否显示准入条件
    isAccessCondition: true,
    //实名是否显示管理员手机号
    isRealAdminPhone: true,
    //实名流程是否显示父级流程
    flowRealShowParent: false,
    //实名流程是否显示当前流程
    flowRealShowStep: true,
    //准入流程大节点扩展
    accessNodeMap: {},
    //实名流程大节点扩展
    realNodeMap: {},
    //账户流程节点扩展
    accountNodeMap: {},
  },
  //融资配置
  finance: {
    //融资失败是否可以重新进行融资
    retryWhenFailed: false,
  },
  //扩展的组件
  extends: {
    //查询组件
    search: {
      unConfirm, // 首页
      loanSearch, // 交易管理融资记录
      repaySearch, // 交易管理还款记录
      receiveableSearch, //应收账款管理
      confirmSearch, //确权管理
      supplierSearch, //我的供应商
      protocolSearch, //合同管理
    },
  },
  //列表项自定义列头
  columnFilter: {
    //可融资列表项
    financeableColumns: [
      'originNo',
      'buyerName',
      'buyerName',
      'validAmount',
      'financeRate',
      'canFinanceAmount',
      'payState',
      'createdDate',
      'operate',
    ],
    receiveableColumns: [
      'originNo',
      'buyerName',
      'buyerName',
      'validAmount',
      'financeRate',
      'canFinanceAmount',
      'state',
      'createdDate',
      'operate',
    ],
  },
  //公共模块自定义设置，如企业信息展示、账户等
  common: {
    enterprise: {
      //企业认证信息
      auth: {
        title: '认证信息',
        filter: ['companyName', 'uscc', 'officeAddress', 'address', 'opExpireDate', 'cellphone'],
      },
      //企业法人信息
      legal: {
        title: '法人信息',
        filter: ['legalName', 'legalCardNo', 'phone', 'legalExpireDate'],
      },
      //紧急联系人信息，中海油不需要的
      contact: {
        title: '紧急联系人信息',
        filter: ['personName', 'relationship', 'personCellphone', 'operate'],
      },
    },
    // 转换url
    convertUrl(params) {
      let linkUrl = ''
      const convert = function(url) {
        // eslint-disable-next-line no-undef
        if (__MODE__ !== 'release') {
          if (url.indexOf('/api') !== -1) {
            return `${url}`
          } else {
            return `/api${url}`
          }
        } else {
          let urls = url.split('?')
          let base = urls[0]
          let params = urls[1]
          base = base.replace('/api', '')
          let code = base.replace(/\//g, '.').replace(/(^\s*)|(\s*$)/g, '')
          let search = new URLSearchParams(params)
          search.append('apiCode', `right.yfz${code}`) //预发 cj.yfz | 生产right.yfz
          return `//jnos-api-cloud.crxn.cn${base}?${search.toString()}`
        }
      }
      if (typeof params === 'object') {
        linkUrl = convert(params.url)
      } else {
        linkUrl = convert(params)
      }
      return linkUrl
    },
    // 转换合同url
    converSignUrl(url) {
      let newUrl = url.replace(/http.*?\.(cn|com)/g, window.location.origin)
      return newUrl
    },
    loginUrl() {
      return `//account.crxn.cn/user/login?productCode=b2b&returnUrl=${encodeURIComponent(window.location.href)}`
    },
  },
  //覆盖接口调用，用于不同项目同一功能接口不同
  overrideMap: {
    //开通校验
    isOpenProduct: '/api/page/yfz/access/venderInfo',
    queryOrderInfo: '/api/page/finance/apply/order/externalSubjectInit',
  },
}

export * from './router'
